<template>
  <div class="bg-white pb-24 sm:pb-32">
    <div class="mx-auto mt-40 max-w-7xl px-6 lg:px-8">
      <div class="mx-auto lg:mx-0">
        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our Team</h2>
        <p class="mt-6 text-lg leading-8 text-gray-600">We're a dynamic group of individuals who are passionate about what we do.</p>
      </div>
      <!-- SLT -->
      <div class="mx-auto lg:mx-0">
        <h2 class="text-3xl mt-6 font-bold tracking-tight text-gray-900 sm:text-4xl">Our Senior Leadership Team</h2>
      </div>
      <ul role="list" class="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <li v-for="person in slt" :key="person.name">
          <img class="aspect-[2/3] w-full rounded-2xl object-cover" :src="person.imageUrl" alt="" />
          <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{{ person.name }}</h3>
          <p class="text-base leading-7 text-gray-600">{{ person.role }}</p>
          <div class="text-base leading-7 text-gray-600">
            <a :href="'mailto:' + person.email" class="inline-block w-full text-blue-500 hover:underline">
              {{ person.email }}
            </a>
          </div>
        </li>
      </ul>

      <div class="mx-auto lg:mx-0">
        <h2 class="text-3xl mt-20 font-bold tracking-tight text-gray-900 sm:text-4xl">Teaching Staff</h2>
      </div>
      <ul role="list" class="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <li v-for="person in teachingStaff" :key="person.name">
          <img class="aspect-[2/3] w-full rounded-2xl object-cover" :src="person.imageUrl" alt="" />
          <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{{ person.name }}</h3>
          <p class="text-base leading-7 text-gray-600">{{ person.role }}</p>
          <div class="text-base leading-7 text-gray-600">
            <a :href="'mailto:' + person.email" class="inline-block w-full text-blue-500 hover:underline">
              {{ person.email }}
            </a>
          </div>
        </li>
      </ul>

      <!-- Office -->
      <div class="mx-auto lg:mx-0">
        <h2 class="text-3xl mt-20 font-bold tracking-tight text-gray-900 sm:text-4xl">Our Office Staff</h2>
      </div>
      <ul role="list" class="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <li v-for="person in office" :key="person.name">
          <img class="aspect-[2/3] w-full rounded-2xl object-cover" :src="person.imageUrl" alt="" />
          <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{{ person.name }}</h3>
          <p class="text-base leading-7 text-gray-600">{{ person.role }}</p>
          <div class="text-base leading-7 text-gray-600">
            <a :href="'mailto:' + person.email" class="inline-block w-full text-blue-500 hover:underline">
              {{ person.email }}
            </a>
          </div>
        </li>
      </ul>

      <!-- Maintenance -->
      <div class="mx-auto lg:mx-0">
        <h2 class="text-3xl mt-20 font-bold tracking-tight text-gray-900 sm:text-4xl">Our Grounds and Maintenance Staff</h2>
      </div>
      <ul role="list" class="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <li v-for="person in maintenance" :key="person.name">
          <img class="aspect-[2/3] w-full rounded-2xl object-cover" :src="person.imageUrl" alt="" />
          <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{{ person.name }}</h3>
          <p class="text-base leading-7 text-gray-600">{{ person.role }}</p>
          <div class="text-base leading-7 text-gray-600">
            <a :href="'mailto:' + person.email" class="inline-block w-full text-blue-500 hover:underline">
              {{ person.email }}
            </a>
          </div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script setup>
import RachelImage from '@/assets/staff/Rachel_Woodley-Higgins_PVIS2022.jpg';
import BetsyImage from '@/assets/staff/Betsy_Adams_PVIS2022.jpg';
import JocelyneImage from '@/assets/staff/Jocelyne_Melteres_PVIS2022.jpg';
import BrigitteImage from '@/assets/staff/Brigitte_Bailey_PVIS2022.jpg';
import MerelynImage from '@/assets/staff/Merelyn_Peter_PVIS2022.jpg';
import SophieImage from '@/assets/staff/Sophie_Nathaniel_PVIS2022.jpg';
import BettyObedImage from '@/assets/staff/Betty_Obed_PVIS2022.jpg';
import CarolineImage from '@/assets/staff/Caroline_Timas_PVIS2022.jpg';
import ChristellaImage from '@/assets/staff/Christella_Kalsrap_PVIS2022.jpg';
import DerrleenImage from '@/assets/staff/Derrleen_Tari_PVIS2022.jpg';
import EssieImage from '@/assets/staff/Essie_Farro_PVIS2022.jpg';
import EstherImage from '@/assets/staff/Esther_Kamen_PVIS2022.jpg';
import JudithImage from '@/assets/staff/Judith_Hosea_PVIS2022.jpg';
import JulesImage from '@/assets/staff/Jules_Poindy_PVIS2022.jpg';
import MaxiImage from '@/assets/staff/Maxi_PeytonJerram-Snell_PVIS2022.jpg';
import MelImage from '@/assets/staff/Mel_Shem_PVIS2022.jpg';
import NaomiImage from '@/assets/staff/Naomi_Aniel_Shem_PVIS2022.jpg';
import NorahImage from '@/assets/staff/Norah_Pakoa_PVIS2022.jpg';
import SanreImage from '@/assets/staff/Sanre_Arsen_PVIS2022.jpg';
import MarthaImage from '@/assets/staff/Martha_Titek _PVIS2022.jpg';
import MatchamImage from '@/assets/staff/Caine-Matcham-2025.jpg';
import CeliaParryImage from '@/assets/staff/Parry-Celia-2025.jpg';
import GabrielleImage from '@/assets/staff/Gabrielle_Jackson_PVIS2022.jpg';
import FinaImage from '@/assets/staff/Fina_Samuel_PVIS2022.jpg';
import AnnieImage from '@/assets/staff/Annie_Obed_PVIS2022.jpg';
import MolimaliImage from '@/assets/staff/Molimali_Jacob_PVIS2022.jpg';
import RoseImage from '@/assets/staff/Rose_Lobban_PVIS2022.jpg';
import AbyImage from '@/assets/staff/Aby_John_PVIS2022.jpg';
import KimberleyImage from '@/assets/staff/Kimberley_Leversha.jpg';
import JanettaImage from '@/assets/staff/Janetta_Achary_PVIS2022.jpg';
import JohnImage from '@/assets/staff/John_Makia_PVIS2022.jpg';
import NorahIshmaelImage from '@/assets/staff/Norah_Ishmael _PVIS2022.jpg';
import DonnaMcKenzieImage from '@/assets/staff/Donna_Mckenzie_PVIS2024.jpg';
import JenniferWhiteleyImage from '@/assets/staff/Jennifer_Whiteley_PVIS2024.jpg';
import ReginaBaniImage from '@/assets/staff/Regina_Bani_PVIS2024.jpg';
import AnnaMaelImage from '@/assets/staff/Anna_Mael_PVIS2024.jpg';
import DickMolteImage from '@/assets/staff/Dick_Molte_PVIS2024.jpg';
import ViollaSuraiImage from '@/assets/staff/Violla_Surai_PVIS2024.jpg';
import SharonLiatlatmalImage from '@/assets/staff/Sharon_Liatlatmal_PVIS2024.jpg';
import LoramakinsImage from '@/assets/staff/Loramakins_Saul_PVIS2024.jpg';
import PaulTomakiakaiImage from '@/assets/staff/Paul_Tomakiakai_PVIS2024.jpg';
import AnnloraNalauImage from '@/assets/staff/Nalau-Annlora-2025.jpg';
import DaniellaJeneryImage from '@/assets/staff/Daniella-Jenery-2025.jpg';
import JosieRicheyImage from '@/assets/staff/Richey-Josie-2025.jpg';
import SharnyChapmanImage from '@/assets/staff/Chapman-Sharny-2025.jpg';
import AshWickramageImage from '@/assets/staff/Wickramage-Ash-2025.jpg';
import ToriWebsterImage from '@/assets/staff/Webster-Tori-2025.jpg';
import RachaelWhiteImage from '@/assets/staff/White-Rachael-2025.jpg';
import YonelNimbwenImage from '@/assets/staff/Nimbwen-Yonel-2025.jpg';
import EvelynMartinBlakeyImage from '@/assets/staff/Martin-Blakey-Evelyn-2025.jpg';
import LlewellynImage from '@/assets/staff/Llewellyn-2025.jpg';
import MaddieReesorImage from '@/assets/staff/Reesor-Maddie-2025.jpg';
import JulieLapeyreImage from '@/assets/staff/Lapeyre-Julie-2025.jpg';
import VirginieBernierImage from '@/assets/staff/Bernier-Virginie-2025.jpg';
import BirtukanMassinImage from '@/assets/staff/Massin-Birtukan-2025.jpg';
import EzekielBersaksakImage from '@/assets/staff/Bersaksak-Ezekiel-2025.jpg';
import JohnHenryImage from '@/assets/staff/John-Henry-2025.jpg';
import PatricianneShouldice2025Image from '@/assets/staff/Shouldice-Patricianne-2025.jpg';
import ErinaWaitai2025Image from '@/assets/staff/Waitai-Erina-2025.jpg';
import LeisaleImage from '@/assets/staff/Leisale-2025.jpg';
import JamesSlaterImage from '@/assets/staff/James-Slater-2025.jpg';
import MichelleChesterImage from '@/assets/staff/Michelle-Chester-2025.jpg';
import AndyChapmanImage from '@/assets/staff/Chapman-Andy-2025.jpg';
import CatherineBurnsImage from '@/assets/staff/Cathy-Burns-2025.jpg';
import PaulineBakeoImage from '@/assets/staff/Bakeo-Pauline-2025.jpg';

const slt = [
  {
    name: 'Rachel Woodley-Higgins',
    role: 'Principal',
    email: 'rachel.woodley-higgins@pvis.edu.vu',
    imageUrl: RachelImage,
  },
  {
    "name": "Celia Parry",
    "role": "Director of Finance",
    "email": "celia.parry@pvis.edu.vu",
    imageUrl: CeliaParryImage,
  },
  {
    name: 'Patricianne Shouldice',
    role: 'Director of Early Education & Operations',
    email: "patricianne.shouldice@pvisv.edu.vu",
    imageUrl: PatricianneShouldice2025Image,
  },
  {
    "name": "Kimberley Leversha",
    "role": "Head of Junior School -  Primary Teacher",
    "email": "kimberley.leversha@pvis.edu.vu",
    imageUrl: KimberleyImage,
  },
  {
    "name": "Erina Waitai",
    "role": "Head of Middle School - Year 5-6 Teacher",
    "email": "erina.waitai@pvis.edu.vu",
    imageUrl: ErinaWaitai2025Image,
  },
  {
    "name": "Matcham Caine",
    "role": "Head of Senior School - HASS and Business Teacher",
    "email": "matcham.caine@pvis.edu.vu",
    imageUrl: MatchamImage,
  },
]

const teachingStaff = [
  {
    "name": "Aby John",
    "role": "Teaching Assistant (Sports and Maintenance)",
    imageUrl: AbyImage,
  },
  {
    "name": "Annie Obed",
    "role": "Teaching Assistant",
    imageUrl: AnnieImage,
  },
  {
    "name": "Andy Chapman",
    "role": "Music and Relief Teacher",
    "email": "andy.chapman@pvis.edu.vu",
    imageUrl: AndyChapmanImage,
  },
  {
    "name": "Annlora Nalau",
    "role": "EEC Educator",
    imageUrl: AnnloraNalauImage,
  },
  {
    "name": "Ash Wickramage",
    "role": "Humanities Teacher",
    "email": "ash.wickramage@pvis.edu.vu",
    imageUrl: AshWickramageImage,
  },
  {
    "name": "Betsy Adams",
    "role": "Teaching Assistant",
    imageUrl: BetsyImage,
  },
  {
    "name": "Betty Obed",
    "role": "Teaching Assistant",
    imageUrl: BettyObedImage,
  },
  {
    "name": "Birtukan Massin",
    "role": "PE Teacher",
    "email": "birtukan.massin@pvis.edu.vu",
    imageUrl: BirtukanMassinImage,
  },
  {
    "name": "Brigitte Bailey",
    "role": "Student Leadership Coordinator & Middle School Teacher",
    imageUrl: BrigitteImage,
  },
  {
    "name": "Catherine Burns",
    "role": "Teacher",
    "email": "catherine.burns@pvis.edu.vu",
    imageUrl: CatherineBurnsImage,
  },
  {
    "name": "Christella Kalsrap",
    "role": "Teaching Assistant",
    imageUrl: ChristellaImage,
  },
  {
    "name": "Daniella Jenery",
    "role": "Teaching Assistant",
    imageUrl: DaniellaJeneryImage,
  },
  {
    "name": "Donna Mckenzie",
    "role": "Preschool Teacher",
    "email": "donna.mckenzie@pvis.edu.vu",
    imageUrl: DonnaMcKenzieImage,
  },
  {
    "name": "Essie Farro",
    "role": "Teaching Assistant",
    imageUrl: EssieImage,
  },
  {
    "name": "Evelyn Martin-Blakey",
    "role": "Science, Maths, English Teacher",
    "email": "evelyn.blakey@pvis.edu.vu",
    imageUrl: EvelynMartinBlakeyImage,
  },
  {
    "name": "Fina Samuel",
    "role": "Teaching Assistant",
    imageUrl: FinaImage,
  },
  {
    "name": "Gabrielle Jackson",
    "role": "Year 3/4 Teacher",
    "email": "gabby.jackson@pvis.edu.vu",
    imageUrl: GabrielleImage,
  },
  {
    "name": "James Slater",
    "role": "Year 5-6 Teacher",
    "email": "james.slater@pvis.edu.vu",
    imageUrl: JamesSlaterImage,
  },
  {
    "name": "Janetta Achary",
    "role": "Teacher",
    "email": "janetta.achary@pvis.edu.vu",
    imageUrl: JanettaImage,
  },
  {
    "name": "Jennifer Whiteley",
    "role": "English & Art Teacher, Sace Coordinator",
    "email": "jennifer.whiteley@pvis.edu.vu",
    imageUrl: JenniferWhiteleyImage,
  },
  {
    "name": "Jocelyne Melteres",
    "role": "EEC Educator",
    imageUrl: JocelyneImage,
  },
  {
    "name": "John Henry",
    "role": "Art, Design, Outdoor Ed",
    "email": "john.henry@pvis.edu.vu",
    imageUrl: JohnHenryImage,
  },
  {
    "name": "Josie Richey",
    "role": "Year 3/4 Teacher",
    "email": "josie.richey@pvis.edu.vu",
    imageUrl: JosieRicheyImage,
  },
  {
    "name": "Judith Hosea",
    "role": "Teaching Assistant",
    imageUrl: JudithImage,
  },
  {
    "name": "Julie Lapeyre",
    "role": "French Teacher",
    "email": "julie.lapeyre@pvis.edu.vu",
    imageUrl: JulieLapeyreImage,
  },
  {
    "name": "Leisale Roberts",
    "role": "English and Pasifika Studies Teacher",
    "email": "leisale.roberts@pvis.edu.vu",
    imageUrl: LeisaleImage,
  },
  {
    "name": "Llewellyn Samuels",
    "role": "Maths and Science Teacher",
    "email": "llewellyn.samuel@pvis.edu.vu",
    imageUrl: LlewellynImage,
  },
  {
    "name": "Loramakins Saul",
    "role": "EEC Educator",
    imageUrl: LoramakinsImage,
  },
  {
    "name": "Maddie Reesor",
    "role": "PE & Maths Teacher",
    "email": "maddie.reesor@pvis.edu.vu",
    imageUrl: MaddieReesorImage,
  },
  {
    "name": "Martha Titek",
    "role": "Teaching Assistant (Mathematics and Science)",
    imageUrl: MarthaImage,
  },
  {
    "name": "Maxi PeytonJerram-Snell",
    "role": "Year 1/2 Teacher",
    "email": "maxi.snell@pvis.edu.vu",
    imageUrl: MaxiImage,
  },
  {
    "name": "Mel Shem",
    "role": "Teaching Assistant",
    imageUrl: MelImage,
  },
  {
    "name": "Merelyn Peter",
    "role": "Preschool Teacher",
    "email": "merelyn.peter@pvis.edu.vu",
    imageUrl: MerelynImage,
  },
  {
    "name": "Michelle Chester",
    "role": "Year 3/4 Teacher",
    "email": "michelle.chester@pvis.edu.vu",
    imageUrl: MichelleChesterImage,
  },
  {
    "name": "Molimali Jacob",
    "role": "Year 7/8 Teacher",
    "email": "molimali.jacob@pvis.edu.vu",
    imageUrl: MolimaliImage,
  },
  {
    "name": "Naomi Aniel Shem",
    "role": "Library Coordinator",
    "email": "naomi.shem@pvis.edu.vu",
    imageUrl: NaomiImage,
  },
  {
    "name": "Pauline Bakeo",
    "role": "",
    imageUrl: PaulineBakeoImage,
  },
  {
    "name": "Rachael White",
    "role": "Year 5/6 Teacher",
    "email": "rachael.white@pvis.edu.vu",
    imageUrl: RachaelWhiteImage,
  },
  {
    "name": "Rose Lobban",
    "role": "Wellbeing Coordinator & Secondary Teacher",
    "email": "rose.lobban@pvis.edu.vu",
    imageUrl: RoseImage,
  },
  {
    "name": "Sharny Chapman",
    "role": "Music and Relief Teacher",
    "email": "sharny.chapman@pvis.edu.vu",
    imageUrl: SharnyChapmanImage,
  },
  {
    "name": "Sharon Liatlatmal",
    "role": "Teaching Assistant",
    imageUrl: SharonLiatlatmalImage,
  },
  {
    "name": "Sophie Nathaniel",
    "role": "EEC Educator",
    imageUrl: SophieImage,
  },
  {
    "name": "Tori Webster",
    "role": "Year 1/2 Teacher",
    "email": "tori.webster@pvis.edu.vu",
    imageUrl: ToriWebsterImage,
  },
  {
    "name": "Violla Surai",
    "role": "Teaching Assistant",
    imageUrl: ViollaSuraiImage,
  },
  {
    "name": "Virginie Bernier",
    "role": "French",
    "email": "virginie.bernie@pvis.edu.vu",
    imageUrl: VirginieBernierImage,
  },
  {
    "name": "Yonel Nimbwen Harrison",
    "role": "Maths and Science Teacher",
    "email": "yonel.nimbwen@pvis.edu.vu",
    imageUrl: YonelNimbwenImage,
  },
]

const office = [
  {
    "name": "Ezekiel Bersaksak",
    "role": "Administration Office",
    imageUrl: EzekielBersaksakImage,
  },
  {
    "name": "Regina Bani",
    "role": "Accounting and Administration Office",
    "email": "accounts@pvis.edu.vu",
    imageUrl: ReginaBaniImage,
  },
  {
    "name": "Derrleen Tari",
    "role": "School and Human Resources Manager & Principal's PA",
    "email": "derrleen.tari@pvis.edu.vu",
    imageUrl: DerrleenImage,
  },
  {
    "name": "John Makia",
    "role": "ICT Support Officer",
    "email": "ict.support@pvis.edu.vu",
    imageUrl: JohnImage,
  },
  {
    "name": "Anna Mael",
    "role": "Receptionist",
    "email": "admin@pvis.edu.vu",
    imageUrl: AnnaMaelImage,
  },
]

const maintenance = [
  {
    "name": "Norah Pakoa",
    "role": "Cleaner",
    "email": null,
    imageUrl: NorahImage,
  },
  {
    "name": "Norah Ishmael",
    "role": "Cleaner",
    "email": null,
    imageUrl: NorahIshmaelImage,
  },
  {
    "name": "Esther Kamen",
    "role": "Cleaner",
    "email": null,
    imageUrl: EstherImage,
  },
  {
    "name": "Caroline Timas",
    "role": "Cleaner",
    "email": null,
    imageUrl: CarolineImage,
  },
  {
    "name": "Jules Poindy",
    "role": "Maintenance & Grounds",
    "email": null,
    imageUrl: JulesImage,
  },
  {
    "name": "Sanre Arsen",
    "role": "Maintenance & Grounds",
    "email": null,
    imageUrl: SanreImage,
  },
  {
    "name": "Paul Tomakiakai",
    "role": "Maintenance & Grounds",
    "email": null,
    imageUrl: PaulTomakiakaiImage,
  },
  {
    "name": "Dick Molte",
    "role": "Maintenance & Grounds",
    "email": null,
    imageUrl: DickMolteImage,
  }
]

</script>
